import axios from 'axios';
import { TrafficChartData } from './Ga4TrafficFetcher';

const QUICKCHART_URL = 'https://quickchart.io/chart';
const CHART_WIDTH = 680;
const CHART_HEIGHT = 300;

/**
 * Generate a traffic chart PNG via QuickChart.io.
 * Returns a Buffer containing the PNG image, or null on failure.
 */
export async function generateTrafficChart(
  chart: TrafficChartData,
  hasLeads: boolean,
): Promise<Buffer | null> {
  try {
    const datasets: any[] = [
      {
        label: 'Unique Users',
        data: chart.users,
        borderColor: '#3b82f6',
        backgroundColor: 'rgba(59,130,246,0.08)',
        fill: true,
        pointRadius: 3,
        pointBackgroundColor: '#3b82f6',
        borderWidth: 2,
        lineTension: 0.3,
        yAxisID: 'y',
      },
    ];

    const yAxes: any[] = [
      {
        id: 'y',
        position: 'left',
        scaleLabel: { display: true, labelString: 'Unique Users' },
        ticks: { beginAtZero: true },
      },
    ];

    if (hasLeads && chart.leads.length > 0) {
      datasets.push({
        label: 'Traffic Leads',
        data: chart.leads,
        borderColor: '#22c55e',
        backgroundColor: 'rgba(34,197,94,0.08)',
        fill: true,
        pointRadius: 3,
        pointBackgroundColor: '#22c55e',
        borderWidth: 2,
        lineTension: 0.3,
        yAxisID: 'y1',
      });
      yAxes.push({
        id: 'y1',
        position: 'right',
        scaleLabel: { display: true, labelString: 'Traffic Leads' },
        ticks: { beginAtZero: true },
        gridLines: { drawOnChartArea: false },
      });
    }

    // Chart.js v2 config (QuickChart default)
    const chartConfig = {
      type: 'line',
      data: {
        labels: chart.dates,
        datasets,
      },
      options: {
        legend: { position: 'bottom', labels: { fontSize: 11 } },
        scales: { yAxes },
        layout: { padding: { top: 5, right: 10 } },
      },
    };

    const response = await axios.post(
      QUICKCHART_URL,
      {
        chart: JSON.stringify(chartConfig),
        width: CHART_WIDTH,
        height: CHART_HEIGHT,
        format: 'png',
        backgroundColor: 'white',
      },
      {
        responseType: 'arraybuffer',
        timeout: 15000,
      },
    );

    return Buffer.from(response.data);
  } catch (err) {
    console.error('QuickChart generation failed:', err);
    return null;
  }
}
